/* eslint-disable no-debugger */
import { AvatarModal } from 'components/avatar-modal';
// import Header from 'components/header';
import { NavMobile } from 'components/nav-mobile';
import { RegulamentoModal } from 'components/regulamento-modal';
// import Sidebar from 'components/sidebar';
// import { TabBar } from 'components/tabbar';
import { ReactNode, useContext, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { validateUserPermissions } from '../utils/validateUserPermissions';
import UserTutorial from 'components/user-tutorial';

interface IPrivateRoute {
  permissions?: string[];
  roles?: string[];
  redirectTo?: string;
  children: ReactNode;
}

export function PrivateRoute({ permissions, roles, redirectTo = '/login', children }: IPrivateRoute) {
  const { isAuthenticated, user, userInfo } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [tutorialClose, setTutorialClose] = useState(false);

  const { hasAllPermissions } = validateUserPermissions({
    user,
    permissions,
    roles,
  });

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' });

  if (!isAuthenticated) {
    if (location.pathname !== '/login' && location.pathname !== '/') {
      sessionStorage.setItem('return', location.pathname);
    }

    return <Navigate to={redirectTo} />;
  }

  if (!hasAllPermissions) {
    return <Navigate to="/" />;
  }

  return (
    <>
      {isTabletOrMobile && <NavMobile />}
      <>{children}</>
      {user?.extra?.id && (tutorialClose || userInfo?.is_manager || user?.extra?.tutorial) && <RegulamentoModal />}
      <AvatarModal />
      {user?.extra?.id && <UserTutorial onClose={() => setTutorialClose(true)} />}
    </>
  );
}
